import { render } from "./ClockControls.vue?vue&type=template&id=266cbe42&scoped=true"
import script from "./ClockControls.vue?vue&type=script&lang=js"
export * from "./ClockControls.vue?vue&type=script&lang=js"

import "./ClockControls.vue?vue&type=style&index=0&id=266cbe42&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-266cbe42"]])

export default __exports__